import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetch } from "../../../Util/axios_helper";

const initialState = {
  ExecutionData: [],
  ExecutionDataLoaded: false,
};
export const GetExecutionData = createAsyncThunk(
  "GetExecutionData",
  async (obj) => {
    return await fetch(
      `Analytics/Get_ExecutionData?type=${obj.type}&years=${obj.years}&filter=${obj.filter}&metrics=${obj.metrics}&value=${obj.value}`
    );
  }
);

const ExecutionSlice = createSlice({
  name: "execution",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(GetExecutionData.pending, (state) => {
      state.ExecutionDataLoaded = false;
    });
    builder.addCase(GetExecutionData.fulfilled, (state, data) => {
      state.ExecutionData = data.payload;
      state.ExecutionDataLoaded = true;
    });
    builder.addCase(GetExecutionData.rejected, (state) => {
      state.ExecutionDataLoaded = true;
      state.ExecutionData = null;
    });
  },
});

export default ExecutionSlice.reducer;
